import { MouseEvent, ReactElement } from 'react';
import { config } from '@client/config';
import { useActiveLanguage, useTranslate } from '@client/i18n/hooks';
import { ROUTES } from '@client/routes/components/Router/routes';
import { useRouterPush, useUrlCreator } from '@client/routes/hooks';
import { getCategoryUrlParams, openLink } from '@client/routes/utils/url';
import classNames from 'classnames';
import { Button, BUTTON_SIZE, BUTTON_STYLE_TYPE } from 'b2b-components/theme/components/Button';
import inkFinderIcon from './assets/inkfinder.svg';
import { INK_CATEGORY_URL, LABEL_TYPE, Props, STYLE_TYPE } from './InkFinderLink.types';
import './InkFinderLink.scss';


export const InkFinderLink = (props: Props): ReactElement | null => {
  const isVisible = config.features.inkTonerFinder;
  const t = useTranslate();
  const push = useRouterPush();
  const urlCreator = useUrlCreator();
  const lang = useActiveLanguage();

  if (!isVisible) {
    return null;
  }

  const url = `${urlCreator(ROUTES.category)}${getCategoryUrlParams(INK_CATEGORY_URL[lang])}`;

  const handleClick = (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
    e.preventDefault();
    openLink(url, push);
  };

  const {
    className,
    labelType = LABEL_TYPE.default,
    styleType = STYLE_TYPE.default,
  } = props;
  const rootClassName = classNames(
    'InkFinderLink',
    className, {
      'InkFinderLink--Big': styleType === STYLE_TYPE.big,
    },
  );
  const text = {
    tinteTonerFinder: t('Tinte & Toner Finder'),
    findSupplies: t('Find supplies'),
  };

  if (styleType === STYLE_TYPE.big) {
    return (
      <div
        className={rootClassName}
      >
        <img className='InkFinderLink-Logo' src={inkFinderIcon} alt={'inkfinder logo'} />
        <span className='InkFinderLink-Label'>
          {labelType === LABEL_TYPE.default
            ? text.findSupplies
            : text.tinteTonerFinder}
        </span>
        <Button
          className='InkFinderLink-Button'
          size={BUTTON_SIZE.small}
          styleType={BUTTON_STYLE_TYPE.secondary}
          onClick={handleClick}
        >
          {text.findSupplies}
        </Button>
      </div>
    );
  }

  return (
    <a
      className={rootClassName}
      href={url}
      onClick={handleClick}
    >
      <img className='InkFinderLink-Logo' src={inkFinderIcon} alt={'inkfinder logo'} />
      {labelType === LABEL_TYPE.default
        ? text.findSupplies
        : text.tinteTonerFinder}
    </a>
  );
};

